import React, { useCallback, useEffect, useState, useRef, forwardRef, useImperativeHandle } from "react";
import { useFormik, FormikProvider, FieldArray } from "formik";
import { useNavigate } from "react-router-dom";
import ToastDialog from "components/Common/ToastDialog";
import JoditEditor from "jodit-react";
import { getOneDeal, downloadCamProfile, getDeal } from "http/fundLync/deal.helper";
import {
  Row,
  Col,
  Form,
  Modal,
  Input,
  ModalHeader,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Table,
} from "reactstrap";
import { downloadSystemConfigFile } from "../../http/UAM/systemConfig.helper";
import { getOneEntity } from "http/fundLync/entityAndAddress.helper";
import { formatDateString, } from "./borrowingProfile";
import { getEmailTemplateByType } from "http/UAM/emailTemplate.helper";
import PropTypes from "prop-types";
import { approveCam, downloadCam, getCamData } from "http/fundLync/cam.helper";
import { callGetCIUser } from "http/fundLync/dealFinancier";
import { decryptedValue, uId } from "common/utility";
import { callDealEsign } from "http/fundLync/query.helper";
import CommonDialog from "components/Common/CommonDialog";
import { useDropzone } from "react-dropzone";
import axios from "axios";
import { API_URL } from "../../http/url.helper";
import Select from "react-select";

const DynamicFileUploadInputForTableRow = ({
  label,
  inputName,
  onDropHandler,
  validation,
  uploadProgress,
  errorMessage,
  index,
}) => {
  const [toastInfo, setToastInfo] = useState({ message: "", showToast: false, role: "" });
  const handleToast = (info) => {
    setToastInfo(info);
  };
  const formatFunction = (file, showToastCallback) => {
    const str = file.substring(file.indexOf("com") + 4);
    const filename = file.substring(file.lastIndexOf("/") + 1);
    const ext = str.split(".").pop();
    const obj = {
      fileName: str,
    };

    downloadSystemConfigFile(obj)
      .then((response) => {
        if (response.code === 200) {
          downloadFile(response.result, ext, filename);
          showToastCallback({
            message: "Downloaded successfully",
            showToast: true,
            role: "success",
          });
        } else {
          showToastCallback({
            message: response.message,
            showToast: true,
            role: "error",
          });
        }
      })
      .catch((error) => {

      });
  };

  const downloadFile = (base64String, ext, fileName) => {
    let source = "";
    if (ext === "zip") {
      source = `data:application/zip;base64,${base64String}`;
    } else {
      source = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64String}`;
    }
    const link = document.createElement("a");
    link.href = source;
    link.download = fileName;
    link.click();
  };
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: onDropHandler,
    multiple: false, // Restrict to one file
    maxFiles: 1,
  });

  const fileName = (filename) => {
    return filename?.substring(filename.lastIndexOf("/") + 1) || "";
  };

  const handleLabelClick = (event) => {
    event.stopPropagation();
    document.getElementById(`${inputName}-${index}`).click();
  };

  const currentFile = validation.values?.documents?.[index]?.[inputName] || null;
  return (
    <React.Fragment>
      <div>
        <Label className="col-sm-6 col-form-label grey">{label}</Label>
        <div
          style={{
            display: "table",
            width: "100%",
            backgroundColor: "#fff",
            border: "dotted 2px #21aa47",
            borderRadius: "5px",
          }}
        >
          <div {...getRootProps()} className="text-wrapper">
            <div className="centered">
              <Input
                type="file"
                name={`${inputName}-${index}`}
                id={`${inputName}-${index}`}
                accept=".jpg, .png, .jpeg, .pdf, .xlsx, .xls"
                {...getInputProps({
                  onClick: (event) => {
                    event.stopPropagation();
                  },
                })}
                style={{ display: "none" }}
              />
              <label
                style={{
                  marginBottom: 0,
                  fontSize: "14px",
                  cursor: "pointer",
                }}
                onClick={handleLabelClick}
              >
                <img
                  src="https://scfuat.cashinvoice.in/frontend/assets/themes/image/icon/cloud.png"
                  className="img-fluid"
                  style={{ width: "30px" }}
                  alt="Upload"
                />
                {isDragActive && <p className="textLink">Drop here</p>}
                <span className="textLink" style={{ padding: "5px" }}>
                  Browse files to attach
                </span>{" "}
                or Drop
              </label>
            </div>
          </div>
        </div>
        {/* Validation Error Display */}
        {validation?.touched?.fileUpload?.[index]?.[inputName] &&
          validation?.errors?.fileUpload?.[index]?.[inputName] && (
            <p className="text-danger font-size-11">
              {validation.errors.fileUpload[index]?.[inputName]}
            </p>
          )}
        {validation.values.documents.length > 0 && validation.values.documents[index]?.fileUpload !== null && (
          <ul className="mt-2">
            <li key={index}>
              <div className="d-flex justify-content-between align-items-center">
                <span>{fileName(currentFile)}</span>
                <div>
                  <i
                    className="mdi mdi-download"
                    style={{
                      fontSize: "20px",
                      cursor: "pointer",
                      color: "#34c38f",
                    }}
                    onClick={() =>
                      formatFunction(validation.values.documents[index]?.fileUpload, handleToast)
                    }
                    id={`download-tooltip-${index}`}
                  ></i>
                  <UncontrolledTooltip
                    placement="top"
                    target={`download-tooltip-${index}`}
                  >
                    Download
                  </UncontrolledTooltip>
                  <i
                    className="mdi mdi-close"
                    style={{
                      fontSize: "20px",
                      cursor: "pointer",
                      color: "#f66b68",
                      fontWeight: "800",
                    }}
                    onClick={() => validation.setFieldValue(
                      `documents[${index}].fileUpload`,
                      null
                    )}
                  ></i>
                </div>
              </div>

            </li>
          </ul>
        )}
        {/* Upload Progress */}
        {uploadProgress > 0 && !errorMessage && (
          <div className="progress mt-4">
            <div
              className="progress-bar bg-success"
              style={{ width: `${uploadProgress}%` }}
              aria-valuenow={uploadProgress}
              aria-valuemin="0"
              aria-valuemax="100"
            >
              {`${uploadProgress}%`}
            </div>
          </div>
        )}
        {/* Error Message */}
        {errorMessage && (
          <div className="alert alert-danger mt-4">{errorMessage}</div>
        )}
      </div>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      />
    </React.Fragment>
  );
};

const TableRow = ({
  onDelete,
  index,
  validation,
  percentageholdingValue,
}) => {
  const [uploadProgress, setUploadProgress] = useState(0);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleInputChange = (field, value) => {
    validation.setFieldValue(`documents[${index}].${field}`, value);
    if (field === "percentageHolding") {
      percentageholdingValue(+value);
    }
  };

  const createOnDropHandler = async (acceptedFiles, cb) => {
    if (!acceptedFiles || acceptedFiles.length === 0) {
      cb({ error: "No files selected" });
      return;
    }

    const file = acceptedFiles[0]; // Safe to access after check
    cb({ percentage: 0 });

    let formData = new FormData();
    formData.append("upl", file);

    const config = {
      onUploadProgress: (progressEvent) => {
        const percentage = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        cb({ percentage });
      },
    };

    try {
      const response = await axios.post(
        `${API_URL}/s3/uploadSystemConfigFiles`,
        formData,
        config
      );
      if (response.status === 200) {
        cb({ file: response.data[0]?.fileName || null });
      } else {
        cb({ error: response.data.message || "Upload failed" });
      }
    } catch (error) {
      cb({ error: error.response?.data?.message || "An error occurred" });
    }
  };


  const onDropForInput = useCallback(async (acceptedFiles) => {
    if (!acceptedFiles || acceptedFiles.length === 0) return;

    await createOnDropHandler(acceptedFiles, (result) => {
      setUploadProgress(result.percentage);
      setErrorMessage(result.error);

      if (result.file) {
        validation.setFieldValue(`documents[${index}].fileUpload`, result.file);
      }
    });
  }, [index, validation]);

  return (
    <tr>
      <td>
        <Label className="col-sm-6 col-form-label grey">File Name</Label>
        <Input
          type="text"
          placeholder="Enter file Name"
          name={`documents[${index}].fileName`}
          id={`documents[${index}].fileName`}
          value={validation.values.documents[index]?.fileName || ""}
          onChange={(e) => handleInputChange("fileName", e.target.value)}
        />
      </td>
      <td style={{ width: "50%" }}>
        <DynamicFileUploadInputForTableRow
          label="Document"
          inputName={`fileUpload`}
          onDropHandler={onDropForInput}
          validation={validation}
          uploadProgress={uploadProgress}
          errorMessage={errorMessage}
          index={index}
        />
      </td>
      <td>
        {validation.values.documents.length > 1 && (
          <i
            className="bx bx-x-circle text-danger"
            onClick={() => onDelete(index)}
            style={{ cursor: "pointer", fontSize: "17px", marginTop: "10px" }}
          />
        )}
      </td>
    </tr>
  );
};

const CamProfile = forwardRef((props, ref) => {
  document.title = "Cam Preview | FundLync";
  const navigate = useNavigate();
  const [entityId, setEntityId] = useState('');
  const [dealDetails, setDealDetails] = useState({});
  const [finacierDetails, setFinacierDetails] = useState([]);
  const [content, setContent] = useState("");
  const [template, setTemplate] = useState('');
  const editor = useRef(null);
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [probeData, setProbeData] = useState('')
  const [entityDetail, setEntityDetail] = useState([]);
  const [isPDF, setPDF] = useState(false)
  const [isApproveModal, setIsApproveModal] = useState(false);
  const [isStatusModal, setIsStatusModal] = useState(false);
  const [userList, setUserList] = useState([]);
  const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });
  const [showCommonDialogApprove, setShowCommonDialogApprove] = useState({ isShow: false });
  const [rows, setRows] = useState([
    {
      fileName: "",
      fileUpload: null
    },
  ]);
  const urlParams = new URLSearchParams(window.location.search);
  const encodedId = urlParams.get("id");
  const encodedDealId = urlParams.get("dealId");
  const dealId = atob(encodedDealId);
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isApproving, setIsApproving] = useState(false);
  const [selectedMulti, setSelectedMulti] = useState([]);
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      dealId: dealId,
      termsheets: content || "",
      id: probeData.id,
      assignedToFirm: probeData?.approvedTo || "",
      documents: rows || [
        {
          fileName: "",
          fileUpload: null,
        },
      ],
    },
    onSubmit: (values) => {
      setConfirmLoading(true);
      const camProfile = {
        camId: probeData.id,
        template: content,
        entityName: entityDetail[0].entityName,
        dealName: dealDetails.dealName,
        approvedTo: values.assignedToFirm,
        probeData: probeData.aboutSection,
        documents: values.documents,
      };
      ;
      const message = 'Are you sure you want to submit this CAM profile?'
      const data = { camProfile }
      setShowCommonDialog({ isShow: true, message, data })
    },
  });

  const validation1 = useFormik({
    enableReinitialize: true,
    initialValues: {
      dealId: dealId,
      financierId: [],
    },
    onSubmit: (values) => {
      setConfirmLoading(true);
      const camProfile = {
        id: dealId, isEsign: 2, camProfile: content, entityName: entityDetail[0].entityName,
        dealName: dealDetails.dealName, documents: validation.values.documents,
        financierData: values.financierId
      };
      const message = 'Are you sure you want to Approve this CAM profile?'
      const data = { camProfile }
      setShowCommonDialogApprove({ isShow: true, message, data })
    },
  });

  const [toastInfo, setToastInfo] = useState({
    message: "",
    showToast: false,
    role: "",
  });

  useEffect(() => {
    if (encodedDealId) {
      getOneDeal({ id: atob(encodedDealId) })
        .then((response) => {
          if (response) {
            setDealDetails(response);
          }
        })
        .catch((error) => {

        });

    }
    if (encodedId) {
      setEntityId(atob(encodedId));
      getOneEntity({ entityId: atob(encodedId) })
        .then((response) => {
          if (response) {
            setEntityDetail(response.data);
          }
        })
        .catch((error) => {
        });
      getCamData({ dealId })
        .then((response) => {
          if (response) {
            setProbeData(response?.data[0] || "")
            setRows(response?.data[0]?.documents || "")
          } else {
            setProbeData([])
          }
        })
        .catch((error) => {
        });
    }
  }, [encodedId, encodedDealId]);

  useEffect(() => {
    if (Object.keys(dealDetails).length === 0) return;
    const camTemplate = `<div class="SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; color: rgb(0, 0, 0); font-family: &quot;Segoe UI&quot;, &quot;Segoe UI Web&quot;, Arial, Verdana, sans-serif; font-style: normal; font-variant-caps: normal; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; white-space: normal; background-color: rgb(255, 255, 255); text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; font-size: 12px;">
        <div class="OutlineElement Ltr SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; clear: both; cursor: text; overflow: visible; position: relative; direction: ltr;">
            <p class="Paragraph SCXW91584501 BCX0" paraid="634952844" paraeid="{0a7869e4-2706-43cb-b906-f11e50cddc8d}{222}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px -1px 0px -38px; padding: 0px; user-select: text; overflow-wrap: break-word; white-space: pre-wrap; font-style: normal; vertical-align: baseline; font-kerning: none; background-color: transparent; color: windowtext; text-align: center; text-indent: 0px;"><span class="EOP SCXW91584501 BCX0" data-ccp-props="{&quot;201341983&quot;:0,&quot;335551550&quot;:2,&quot;335551620&quot;:2,&quot;335559685&quot;:-567,&quot;335559737&quot;:-13,&quot;335559739&quot;:0,&quot;335559740&quot;:240}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; color: rgb(0, 0, 0); font-size: 16px;"><span style="font-variant-ligatures: none;"><strong><u>((entity_name))</u></strong></span>&nbsp;</span></p>
        </div>
        <div class="OutlineElement Ltr SCXW91584501 BCX0" style="font-variant-ligatures: normal; font-weight: 400; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; clear: both; cursor: text; overflow: visible; position: relative; direction: ltr;">
            <p class="Paragraph SCXW91584501 BCX0" paraid="585114253" paraeid="{0a7869e4-2706-43cb-b906-f11e50cddc8d}{230}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px -1px 0px -38px; padding: 0px; user-select: text; overflow-wrap: break-word; white-space: pre-wrap; font-weight: normal; font-style: normal; vertical-align: baseline; font-kerning: none; background-color: transparent; color: windowtext; text-align: center; text-indent: 0px;"><span data-contrast="none" xml:lang="EN-IN" lang="EN-IN" class="TextRun Underlined SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; color: rgb(0, 0, 0); line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; font-variant-ligatures: none !important; font-size: 11pt;"><span class="NormalTextRun SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text;">(((location)))</span></span><span class="EOP SCXW91584501 BCX0" data-ccp-props="{&quot;201341983&quot;:0,&quot;335551550&quot;:2,&quot;335551620&quot;:2,&quot;335559685&quot;:-567,&quot;335559737&quot;:-13,&quot;335559739&quot;:0,&quot;335559740&quot;:240}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; color: rgb(0, 0, 0); font-size: 11pt;">&nbsp;</span></p>
        </div>
        <div  class="OutlineElement Ltr SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; clear: both; cursor: text; overflow: visible; position: relative; direction: ltr; color: rgb(0, 0, 0); font-family: &quot;Segoe UI&quot;, &quot;Segoe UI Web&quot;, Arial, Verdana, sans-serif; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; white-space: normal; background-color: rgb(255, 255, 255); text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; font-size: 12px;>
            <p class="Paragraph SCXW91584501 BCX0" paraid="973186431" paraeid="{0a7869e4-2706-43cb-b906-f11e50cddc8d}{254}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px -1px 0px -38px; padding: 0px; user-select: text; overflow-wrap: break-word; white-space: pre-wrap; font-weight: normal; font-style: normal; vertical-align: baseline; font-kerning: none; background-color: transparent; color: windowtext; text-align: left; text-indent: 0px;"><span data-contrast="auto" xml:lang="EN-US" lang="EN-US" class="TextRun SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; font-variant-ligatures: none !important; font-size: 11pt;"><span class="NormalTextRun SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text;"><strong>About the Proposal :</strong><br>((products)) of </span><span class="NormalTextRun SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text;">((loan_requirement))</span><span class="NormalTextRun SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text;">  </span><span class="NormalTextRun SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text;">f</span><span class="NormalTextRun SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text;">or </span><span class="NormalTextRun SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text;"></span><span class="NormalTextRun SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text;">((entity_name))</span></span><span class="EOP SCXW91584501 BCX0" data-ccp-props="{&quot;201341983&quot;:0,&quot;335551550&quot;:6,&quot;335551620&quot;:6,&quot;335559685&quot;:-567,&quot;335559737&quot;:-13,&quot;335559739&quot;:0,&quot;335559740&quot;:240}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; font-size: 11pt;">&nbsp;</span></p>
        </div>
        <div class="OutlineElement Ltr SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; clear: both; cursor: text; overflow: visible; position: relative; direction: ltr; color: rgb(0, 0, 0); font-family: &quot;Segoe UI&quot;, &quot;Segoe UI Web&quot;, Arial, Verdana, sans-serif; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; white-space: normal; background-color: rgb(255, 255, 255); text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; font-size: 12px;>
            <p class="Paragraph SCXW91584501 BCX0" paraid="383431057" paraeid="{92348b89-550b-460e-b6d0-969d803a9340}{8}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px -1px 0px 0px; padding: 0px; user-select: text; overflow-wrap: break-word; white-space: pre-wrap; font-weight: normal; font-style: normal; vertical-align: baseline; font-kerning: none; background-color: transparent; color: windowtext; text-align: left; text-indent: 0px;"><span data-contrast="none" xml:lang="EN-US" lang="EN-US" class="TextRun Underlined SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; color: rgb(0, 0, 0); line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; font-weight: bold; font-variant-ligatures: none !important; font-size: 11pt;"><span class="NormalTextRun SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text;">Credit Rating: </span><span class="NormalTextRun SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text;font-weight: 400;">: ((credit_rating))</span></span><span class="EOP SCXW91584501 BCX0" data-ccp-props="{&quot;201341983&quot;:0,&quot;335551550&quot;:6,&quot;335551620&quot;:6,&quot;335559685&quot;:-567,&quot;335559737&quot;:-13,&quot;335559739&quot;:0,&quot;335559740&quot;:240}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; color: rgb(0, 0, 0); font-size: 11pt;"><br></span></p>
        </div>
        <div class="OutlineElement Ltr SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; clear: both; cursor: text; overflow: visible; position: relative; direction: ltr; color: rgb(0, 0, 0); font-family: &quot;Segoe UI&quot;, &quot;Segoe UI Web&quot;, Arial, Verdana, sans-serif; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: Justify; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; white-space: normal; background-color: rgb(255, 255, 255); text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; font-size: 12px;>
            <p class="Paragraph SCXW91584501 BCX0" paraid="383431057" paraeid="{92348b89-550b-460e-b6d0-969d803a9340}{8}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px -1px 0px 0px; padding: 0px; user-select: text; overflow-wrap: break-word; white-space: pre-wrap; font-weight: normal; font-style: normal; vertical-align: baseline; font-kerning: none; background-color: transparent; color: windowtext; text-align: left; text-indent: 0px;"><span data-contrast="none" xml:lang="EN-US" lang="EN-US" class="TextRun Underlined SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; color: rgb(0, 0, 0); line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; font-weight: bold; font-variant-ligatures: none !important; font-size: 11pt;"><span class="NormalTextRun SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text;">About ((entity_name)) :</span>
            <p class="Paragraph SCXW91584501 BCX0" paraid="383431057" paraeid="{92348b89-550b-460e-b6d0-969d803a9340}{8}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px -1px 0px 0px; padding: 0px; user-select: text; overflow-wrap: break-word; white-space: pre-wrap; font-weight: normal; font-style: normal; vertical-align: baseline; font-kerning: none; background-color: transparent; color: windowtext; text-align: justify; text-indent: 0px;"><span class="NormalTextRun SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text;">((description))</span></p>
            <p class="Paragraph SCXW91584501 BCX0" paraid="383431057" paraeid="{92348b89-550b-460e-b6d0-969d803a9340}{8}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px -1px 0px 10px; padding: 0px; user-select: text; overflow-wrap: break-word; white-space: pre-wrap; font-weight: normal; font-style: normal; vertical-align: baseline; font-kerning: none; background-color: transparent; color: windowtext; text-align: left; text-indent: 0px;"><span class="EOP SCXW91584501 BCX0" data-ccp-props="{&quot;201341983&quot;:0,&quot;335551550&quot;:6,&quot;335551620&quot;:6,&quot;335559685&quot;:-567,&quot;335559737&quot;:-13,&quot;335559739&quot;:0,&quot;335559740&quot;:240}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; color: rgb(0, 0, 0); font-size: 11pt;"><br></span></p>
        </div>
            ((extraFields))
        <div class="OutlineElement Ltr SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; clear: both; cursor: text; overflow: visible; position: relative; direction: ltr; color: rgb(0, 0, 0); font-family: &quot;Segoe UI&quot;, &quot;Segoe UI Web&quot;, Arial, Verdana, sans-serif; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; white-space: normal; background-color: rgb(255, 255, 255); text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; font-size: 12px;">
            <p class="Paragraph SCXW91584501 BCX0" paraid="383431057" paraeid="{92348b89-550b-460e-b6d0-969d803a9340}{8}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px -1px 0px 0px; padding: 0px; user-select: text; overflow-wrap: break-word; white-space: pre-wrap; font-weight: normal; font-style: normal; vertical-align: baseline; font-kerning: none; background-color: transparent; color: windowtext; text-align: left; text-indent: 0px;"><span data-contrast="none" xml:lang="EN-US" lang="EN-US" class="TextRun Underlined SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; color: rgb(0, 0, 0); line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; font-weight: bold; font-variant-ligatures: none !important; font-size: 11pt;"><span class="NormalTextRun SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text;">List of Directors: </span></span><span class="EOP SCXW91584501 BCX0" data-ccp-props="{&quot;201341983&quot;:0,&quot;335551550&quot;:6,&quot;335551620&quot;:6,&quot;335559685&quot;:-567,&quot;335559737&quot;:-13,&quot;335559739&quot;:0,&quot;335559740&quot;:240}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; color: rgb(0, 0, 0); font-size: 11pt;"><br></span></p>
            <p class="Paragraph SCXW91584501 BCX0" paraid="383431057" paraeid="{92348b89-550b-460e-b6d0-969d803a9340}{8}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px -1px 0px 10px; padding: 0px; user-select: text; overflow-wrap: break-word; white-space: pre-wrap; font-weight: normal; font-style: normal; vertical-align: baseline; font-kerning: none; background-color: transparent; color: windowtext; text-align: left; text-indent: 0px;"><span class="EOP SCXW91584501 BCX0" data-ccp-props="{&quot;201341983&quot;:0,&quot;335551550&quot;:6,&quot;335551620&quot;:6,&quot;335559685&quot;:-567,&quot;335559737&quot;:-13,&quot;335559739&quot;:0,&quot;335559740&quot;:240}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; color: rgb(0, 0, 0); font-size: 11pt;"><br></span></p>
            <table style="width: 100%; border-collapse: collapse; font-size: 12px; margin-top: 2px">
                <thead>
                <tr>
                <th style="border: 1px solid #000; padding: 8px; font-size: 12px; text-align: center">Sr. No.</th>
                    <th style="border: 1px solid #000; padding: 8px; font-size: 12px; text-align: center">Full Name</th>
                    <th style="border: 1px solid #000; padding: 8px; font-size: 12px; text-align: center">Designation</th>
                    <th style="border: 1px solid #000; padding: 8px; font-size: 12px; text-align: center">DIN</th>
                </tr>
                </thead>
                <tbody>
                ((directors))
                </tbody>
            </table>
        </div>
        <p><br></p>
        <div class="OutlineElement Ltr SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; clear: both; cursor: text; overflow: visible; position: relative; direction: ltr; color: rgb(0, 0, 0); font-family: &quot;Segoe UI&quot;, &quot;Segoe UI Web&quot;, Arial, Verdana, sans-serif; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; white-space: normal; background-color: rgb(255, 255, 255); text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; font-size: 12px;">
            <p class="Paragraph SCXW91584501 BCX0" paraid="383431057" paraeid="{92348b89-550b-460e-b6d0-969d803a9340}{8}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px -1px 0px 0px; padding: 0px; user-select: text; overflow-wrap: break-word; white-space: pre-wrap; font-weight: normal; font-style: normal; vertical-align: baseline; font-kerning: none; background-color: transparent; color: windowtext; text-align: left; text-indent: 0px;"><span data-contrast="none" xml:lang="EN-US" lang="EN-US" class="TextRun Underlined SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; color: rgb(0, 0, 0); line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; font-weight: bold; font-variant-ligatures: none !important; font-size: 11pt;"><span class="NormalTextRun SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text;">Shareholding Pattern: </span><span class="NormalTextRun SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text;">As on ((shareHoldingDate)): </span></span><span class="EOP SCXW91584501 BCX0" data-ccp-props="{&quot;201341983&quot;:0,&quot;335551550&quot;:6,&quot;335551620&quot;:6,&quot;335559685&quot;:-567,&quot;335559737&quot;:-13,&quot;335559739&quot;:0,&quot;335559740&quot;:240}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; color: rgb(0, 0, 0); font-size: 11pt;"><br></span></p>
            <p class="Paragraph SCXW91584501 BCX0" paraid="383431057" paraeid="{92348b89-550b-460e-b6d0-969d803a9340}{8}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px -1px 0px 10px; padding: 0px; user-select: text; overflow-wrap: break-word; white-space: pre-wrap; font-weight: normal; font-style: normal; vertical-align: baseline; font-kerning: none; background-color: transparent; color: windowtext; text-align: left; text-indent: 0px;"><span class="EOP SCXW91584501 BCX0" data-ccp-props="{&quot;201341983&quot;:0,&quot;335551550&quot;:6,&quot;335551620&quot;:6,&quot;335559685&quot;:-567,&quot;335559737&quot;:-13,&quot;335559739&quot;:0,&quot;335559740&quot;:240}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; color: rgb(0, 0, 0); font-size: 11pt;"><br></span></p>
            <table style="width: 100%; border-collapse: collapse; font-size: 12px; margin-top: 2px">
                <thead>
                <tr>
                    <th style="border: 1px solid #000; padding: 8px; font-size: 12px; text-align: center">Full Name</th>
                    <th style="border: 1px solid #000; padding: 8px; font-size: 12px; text-align: center">No. of Shares</th>
                    <th style="border: 1px solid #000; padding: 8px; font-size: 12px; text-align: center">Holding %</th>
                </tr>
                </thead>
                <tbody>
                ((shareholdingData))
                </tbody>
            </table>
        </div> 
            ((keyStrenghts))
            ((extraFieldsKeyStrengths))
            ((finSummary))
            ((debtProfile))
            ((customerDetails))
            ((supplierDetails))
        <p><br></p>
            ((termSheet))
        <p><br></p>
        </div>`;

    setTemplate(camTemplate);
  }, [dealDetails, probeData]);

  let columns = []
  let data = []

  useEffect(() => {
    if (Object.keys(dealDetails).length === 0) return;

    // if (dealDetails.termsheetsd) {
    //     setContent(dealDetails.termsheets);
    // } else {
    getEmailTemplateByType({ emailType: 'cam_template' }).then((response) => {
      if (response && response.data && response.data.emailBody) {
        setTemplate(response.data.emailBody)
        const replacedHtml = replacePlaceholders(response.data.emailBody, probeData, entityDetail[0])
        setContent(replacedHtml);
      } else {
        const replacedHtml = replacePlaceholders(template, probeData, entityDetail[0])
        setContent(replacedHtml);
      }
    })
    // }
  }, [probeData, dealDetails, entityDetail, encodedDealId, encodedDealId, template]);

  const formatAmount = (amount) => {
    if (typeof amount === 'number' || (typeof amount === 'string' && !isNaN(amount))) {
      const numericAmount = Number(amount);
      const amountInCrores = numericAmount / 100; // Convert lakhs to crores
      const formattedAmount = amountInCrores === 0
        ? '₹ 0'
        : `₹ ${amountInCrores.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
      return formattedAmount;
    }
    return amount;
  };

  const formatAmountloan = (amount) => {
    if (typeof amount === 'number' || (typeof amount === 'string' && !isNaN(amount))) {
      const numericAmount = Number(amount);
      const crores = numericAmount / 10000000;
      return `₹ ${crores.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Cr`;
    }
    return amount;
  }

  const rowsToSkipFormatting = [
    'TOL/ TNW',
    'EBITDA / Interest (times)',
    'Current Ratio',
    'Debt Equity Ratio',
    'Debtors to sales (days)',
    'Creditors to purchases (days)',
    'Inventory stock (Days)',
    'Cash Conversion (in days)',
    'EBITDA %',
    'PAT %'
  ];

  const formatToTwoDecimal = (num) => {
    if (typeof num === 'number') {
      return num.toFixed(2);
    } else if (typeof num === 'string' && !isNaN(num)) {
      return parseFloat(num).toFixed(2);
    }
    return num;
  };

  const formatWithCommas = (value) => {
    if (typeof value === 'number' || (typeof value === 'string' && !isNaN(value))) {
      return `${Number(value).toLocaleString('en-IN')}`;
    }
    return value;
  };

  const formatconvert = (value) => {
    if (typeof value === 'number' || (typeof value === 'string' && !isNaN(value))) {
      return `₹ ${Number(value).toLocaleString('en-IN')}`;
    }
    return value;
  }

  const formatLenderName = (type) => {
    if (!type) return '-';
    return type
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  const replacePlaceholders = (html, probeData, entityDetail) => {
    let keyStrenghts = '';
    if (probeData?.keyStrength != null && probeData?.keyStrength?.strengths[0]?.title != "") {
      const keyStrengthList = probeData?.keyStrength?.strengths
        .map(item => `<li style="margin-bottom: 8px;"><span style="font-weight: bold">${item?.title}: </span>${item.strenght}</li>`)
        .join('');

      keyStrenghts = `
            <p><br></p>
            <div class="OutlineElement Ltr SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; clear: both; cursor: text; overflow: visible; position: relative; direction: ltr; color: rgb(0, 0, 0); font-family: &quot;Segoe UI&quot;, &quot;Segoe UI Web&quot;, Arial, Verdana, sans-serif; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: Justify; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; white-space: normal; background-color: rgb(255, 255, 255); text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; font-size: 12px;>
            <p class="Paragraph SCXW91584501 BCX0" paraid="383431057" paraeid="{92348b89-550b-460e-b6d0-969d803a9340}{8}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px -1px 0px 0px; padding: 0px; user-select: text; overflow-wrap: break-word; white-space: pre-wrap; font-weight: normal; font-style: normal; vertical-align: baseline; font-kerning: none; background-color: transparent; color: windowtext; text-align: left; text-indent: 0px;"><span data-contrast="none" xml:lang="EN-US" lang="EN-US" class="TextRun Underlined SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; color: rgb(0, 0, 0); line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; font-variant-ligatures: none !important; font-size: 11pt;"><span class="NormalTextRun SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; font-weight: bold">Key Strengths :</span>
            <p class="Paragraph SCXW91584501 BCX0" paraid="383431057" paraeid="{92348b89-550b-460e-b6d0-969d803a9340}{8}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px -1px 0px 0px; padding: 0px; user-select: text; overflow-wrap: break-word; white-space: pre-wrap; font-weight: normal; font-style: normal; vertical-align: baseline; font-kerning: none; background-color: transparent; color: windowtext; text-align: justify; text-indent: 0px;"><span class="NormalTextRun SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text;"><ul >
                        ${keyStrengthList}
                        </ul></span></p>
               
            </div>`;
    }

    let extraFieldsKeyStrengths = ''
    if (probeData?.keyStrength != null && probeData?.keyStrength?.dynamicFieldsData != null && Object.keys(probeData?.keyStrength?.dynamicFieldsData).length > 0) {

      extraFieldsKeyStrengths = Object.entries(probeData.keyStrength.dynamicFieldsData)
        .map(([key, valueArray]) => {

          return `
                <p><br></p>
                <div class="OutlineElement Ltr SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; clear: both; cursor: text; overflow: visible; position: relative; direction: ltr; color: rgb(0, 0, 0); font-family: &quot;Segoe UI&quot;, &quot;Segoe UI Web&quot;, Arial, Verdana, sans-serif; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: Justify; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; white-space: normal; background-color: rgb(255, 255, 255); text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; font-size: 12px;>
                <p class="Paragraph SCXW91584501 BCX0" paraid="383431057" paraeid="{92348b89-550b-460e-b6d0-969d803a9340}{8}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px -1px 0px 0px; padding: 0px; user-select: text; overflow-wrap: break-word; white-space: pre-wrap; font-weight: normal; font-style: normal; vertical-align: baseline; font-kerning: none; background-color: transparent; color: windowtext; text-align: left; text-indent: 0px;"><span data-contrast="none" xml:lang="EN-US" lang="EN-US" class="TextRun Underlined SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; color: rgb(0, 0, 0); line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; font-variant-ligatures: none !important; font-size: 11pt;"><span class="NormalTextRun SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; font-weight: bold">${key} :</span>
                <p class="Paragraph SCXW91584501 BCX0" paraid="383431057" paraeid="{92348b89-550b-460e-b6d0-969d803a9340}{8}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px -1px 0px 0px; padding: 0px; user-select: text; overflow-wrap: break-word; white-space: pre-wrap; font-weight: normal; font-style: normal; vertical-align: baseline; font-kerning: none; background-color: transparent; color: windowtext; text-align: justify; text-indent: 0px;"><span class="NormalTextRun SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text;"><ul >
                ${valueArray
              .map(
                (item) => `
                    <li style="margin-bottom: 8px;"><span style="font-weight: bold">${item?.title}: </span>${item?.value}</li>
                `
              )
              .join("")}
                            </ul></span></p>
                </div>`;
        })
        .join("");
    }
    let extraFields = ''
    if (probeData?.aboutSection?.dynamicFieldsData != null) {
      extraFields = Object.entries(probeData.aboutSection.dynamicFieldsData)
        .map(
          ([key, value]) => `
                    <div class="OutlineElement Ltr SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; clear: both; cursor: text; overflow: visible; position: relative; direction: ltr; color: rgb(0, 0, 0); font-family: &quot;Segoe UI&quot;, &quot;Segoe UI Web&quot;, Arial, Verdana, sans-serif; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: Justify; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; white-space: normal; background-color: rgb(255, 255, 255); text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; font-size: 12px;>
                    <p class="Paragraph SCXW91584501 BCX0" paraid="383431057" paraeid="{92348b89-550b-460e-b6d0-969d803a9340}{8}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px -1px 0px 0px; padding: 0px; user-select: text; overflow-wrap: break-word; white-space: pre-wrap; font-weight: normal; font-style: normal; vertical-align: baseline; font-kerning: none; background-color: transparent; color: windowtext; text-align: left; text-indent: 0px;"><span data-contrast="none" xml:lang="EN-US" lang="EN-US" class="TextRun Underlined SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; color: rgb(0, 0, 0); line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; font-weight: bold; font-variant-ligatures: none !important; font-size: 11pt;"><span class="NormalTextRun SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text;">${key}:</span>
                    <p class="Paragraph SCXW91584501 BCX0" paraid="383431057" paraeid="{92348b89-550b-460e-b6d0-969d803a9340}{8}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px -1px 0px 0px; padding: 0px; user-select: text; overflow-wrap: break-word; white-space: pre-wrap; font-weight: normal; font-style: normal; vertical-align: baseline; font-kerning: none; background-color: transparent; color: windowtext; text-align: justify; text-indent: 0px;"><span class="NormalTextRun SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text;">${value?.value}</span></p>
                    <p class="Paragraph SCXW91584501 BCX0" paraid="383431057" paraeid="{92348b89-550b-460e-b6d0-969d803a9340}{8}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px -1px 0px 10px; padding: 0px; user-select: text; overflow-wrap: break-word; white-space: pre-wrap; font-weight: normal; font-style: normal; vertical-align: baseline; font-kerning: none; background-color: transparent; color: windowtext; text-align: left; text-indent: 0px;"><span class="EOP SCXW91584501 BCX0" data-ccp-props="{&quot;201341983&quot;:0,&quot;335551550&quot;:6,&quot;335551620&quot;:6,&quot;335559685&quot;:-567,&quot;335559737&quot;:-13,&quot;335559739&quot;:0,&quot;335559740&quot;:240}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; color: rgb(0, 0, 0); font-size: 11pt;"><br></span></p>
                    </div>`
        )
        .join("");
    }

    const totalAmount = probeData?.open_charges?.length
      ? probeData.open_charges.reduce((acc, openCharges) => acc + (openCharges.amount || 0), 0)
      : 0;

    const finalTotalAmount = totalAmount > 0 ? formatAmount(totalAmount) : '0';

    const directors = probeData?.directorSharehodlerList?.directorList.length
      ? probeData.directorSharehodlerList?.directorList.map((director, index) => `
            <tr>
                <td style='border:1px solid black; padding: 4px; text-align: center'>${index + 1}</td>
                <td style='border:1px solid black; padding: 4px'>${director.name}</td>
                <td style='border:1px solid black; padding: 4px'>${director.designation || ""}</td>
                <td style='border:1px solid black; padding: 4px; text-align: right'>${director.din || ""}</td>
            </tr>`).join("")
      : "";

    const promotersData = probeData?.directorSharehodlerList?.shareholdingList || [];
    const publicData = probeData?.directorSharehodlerList?.publicShareholdings || [];
    const totalPromoterShares = promotersData.reduce((acc, curr) => acc + (curr.no_of_shares || 0), 0);
    const totalPromoterPercentage = promotersData.reduce((acc, curr) => acc + (curr.percentage_holding || 0), 0);
    const publicPercentage = 100 - totalPromoterPercentage;
    const totalShares = probeData?.directorSharehodlerList?.totalShares || '';
    // const totalShares1 = parseInt(totalShares.replace(/,/g, ''), 10);
    const publicShares = totalShares - totalPromoterShares;
    const promoterRows = promotersData
      .filter(shareholder => shareholder.no_of_shares !== 0)
      .map((shareholder, index) => `
            <tr>
                <td style='border:1px solid black; padding: 4px; padding-left: 20px'>${shareholder.full_name}</td>
                <td style='border:1px solid black; padding: 4px; text-align: right'>${formatWithCommas(shareholder.no_of_shares) || ""}</td>
                <td style='border:1px solid black; padding: 4px; text-align: right'>${formatWithCommas(shareholder.percentage_holding) || ""}%</td>
            </tr>
        `).join("");

    // Add row for public shares (remaining percentage)
    const publicRow = publicData
      .filter(shareholder => shareholder.no_of_shares !== 0)
      .map((shareholder, index) => `
          <tr>
              <td style='border:1px solid black; padding: 4px; padding-left: 20px'>${shareholder.full_name}</td>
              <td style='border:1px solid black; padding: 4px; text-align: right'>${formatWithCommas(shareholder.no_of_shares) || ""}</td>
              <td style='border:1px solid black; padding: 4px; text-align: right'>${formatWithCommas(shareholder.percentage_holding) || ""}%</td>
          </tr>
      `).join("");
    const totalRow = `
          <tr>
              <td colspan="1" style='border:1px solid black; padding: 4px; text-align: center; font-weight: bold'>Total</td>
              <td style='border:1px solid black; padding: 4px; text-align: right; font-weight: bold'>${formatWithCommas(totalShares)}</td>
              <td style='border:1px solid black; padding: 4px; text-align: right; font-weight: bold'>100%</td>
          </tr>
      `;

    // Combine rows
    const shareholdingData = `
          <tr>
              <td colspan="1" style="padding: 4px; text-align: left; font-weight: bold; background-color: #f1f1f1;border:1px solid black;">Promoters</td>
              <td style="padding: 4px;font-weight: bold; background-color: #f1f1f1;border:1px solid black; text-align: right; font-weight: bold;">${formatWithCommas(totalPromoterShares)}</td>
              <td style="padding: 4px; text-align: right; font-weight: bold; background-color: #f1f1f1;border:1px solid black;">${formatWithCommas(totalPromoterPercentage)}%</td>
          </tr>
          ${promoterRows}
          <tr>
              <td colspan="1" style="padding: 4px; text-align: left; font-weight: bold; border:1px solid black; background-color: #f1f1f1;">Public</td>
              <td style="padding: 4px; text-align: right; font-weight: bold; background-color: #f1f1f1;border:1px solid black;">${formatWithCommas(publicShares)}</td>
              <td style="padding: 4px; text-align: right; font-weight: bold; background-color: #f1f1f1;border:1px solid black;">${formatWithCommas(publicPercentage)}%</td>
          </tr>
          ${publicRow}
          ${totalRow}
      `;

    let debtProfile = ""
    if (probeData.debtProfile?.lenderList.length > 0 && probeData.debtProfile?.lenderList[0].lenderLabel != undefined) {
      // Extract lenderList
      const customerList = probeData.debtProfile?.lenderList;
      const customerRows = customerList
        .map(
          debt => `
              <tr>
                <td style='border:1px solid black; padding: 4px; font-size: 12px'>${debt.lenderLabel}</td>
                <td style='border:1px solid black; padding: 4px; font-size: 12px;'>${formatLenderName(debt.type)}</td>
                <td style='border:1px solid black; padding: 4px; font-size: 12px; text-align: right'>${formatconvert(debt.sanctionedAmount)}</td>
                <td style='border:1px solid black; padding: 4px; font-size: 12px; text-align: right'>${formatconvert(debt.outstandingAmount)}</td>
              </tr>
            `
        )
        .join('');

      // Create the dynamic table
      debtProfile = `
             <p><br></p>
            <div class="OutlineElement Ltr SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; clear: both; cursor: text; overflow: visible; position: relative; direction: ltr; color: rgb(0, 0, 0); font-family: &quot;Segoe UI&quot;, &quot;Segoe UI Web&quot;, Arial, Verdana, sans-serif; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; white-space: normal; background-color: rgb(255, 255, 255); text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; font-size: 12px;">
                <p class="Paragraph SCXW91584501 BCX0" paraid="383431057" paraeid="{92348b89-550b-460e-b6d0-969d803a9340}{8}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px -1px 0px 0px; padding: 0px; user-select: text; overflow-wrap: break-word; white-space: pre-wrap; font-weight: normal; font-style: normal; vertical-align: baseline; font-kerning: none; background-color: transparent; color: windowtext; text-align: left; text-indent: 0px;"><span data-contrast="none" xml:lang="EN-US" lang="EN-US" class="TextRun Underlined SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; color: rgb(0, 0, 0); line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; font-weight: bold; font-variant-ligatures: none !important; font-size: 11pt;"><span class="NormalTextRun SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text;">Debt Profile <span class="NormalTextRun SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text;">(In ${probeData?.debtProfile?.unitValue}): </span> </span><span class="NormalTextRun SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: tranparent; margin: 0px; padding: 0px; user-select: text;">Borrowing As Of ${formatDateString(probeData?.debtProfile?.borrowingAsOf)} </span></p>
                <p class="Paragraph SCXW91584501 BCX0" paraid="383431057" paraeid="{92348b89-550b-460e-b6d0-969d803a9340}{8}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px -1px 0px 10px; padding: 0px; user-select: text; overflow-wrap: break-word; white-space: pre-wrap; font-weight: normal; font-style: normal; vertical-align: baseline; font-kerning: none; background-color: transparent; color: windowtext; text-align: left; text-indent: 0px;"><span class="EOP SCXW91584501 BCX0" data-ccp-props="{&quot;201341983&quot;:0,&quot;335551550&quot;:6,&quot;335551620&quot;:6,&quot;335559685&quot;:-567,&quot;335559737&quot;:-13,&quot;335559739&quot;:0,&quot;335559740&quot;:240}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; color: rgb(0, 0, 0); font-size: 11pt;"><br></span></p>
                <table style="width: 100%; border-collapse: collapse; font-size: 12px; margin-top: 2px;">
                <thead>
                    <tr>
                    <th style='border:1px solid black; padding: 8px; font-size: 12px; text-align: center; width:20%'>Lender Name</th>
                    <th style='border:1px solid black; padding: 8px; font-size: 12px; text-align: center; width:20%'>Type</th>
                    <th style='border:1px solid black; padding: 8px; font-size: 12px; text-align: center; width:20%'>Sanctined Amount</th>
                    <th style='border:1px solid black; padding: 8px; font-size: 12px; text-align: center; width:20%'>Outstanding Amount</th>
                    </tr>
                </thead>
                <tbody>
                    ${customerRows}
                </tbody>
                </table>
            </div>
        `;
    }

    const columnWidth = "10%"; // Adjust the width as needed

    const dynamicColumns1 = probeData?.finSummary?.columns?.filter(column => column.key !== 'title').map(column => column.key) || [];

    const dynamicColumns = probeData?.finSummary?.columns
      ?.filter(column => column.key !== 'title')
      .map(column => {
        const year = parseInt(column.key, 10);
        if (!isNaN(year)) {
          if (year === new Date().getFullYear()) {
            return `FY ${year - 1}-${year % 100}`; // Current year format, e.g., 2024 -> Provisional FY 2023-24
          } else {
            return `FY ${year - 1}-${year % 100}`; // Previous years format, e.g., 2023 -> FY 2022-23
          }
        }
        return column.key;
      }) || [];

    const finacialSumaryData = probeData?.finSummary?.data[0]?.data.length
      ? probeData?.finSummary?.data[0]?.data.map((data0) => {
        return `
            <tr>
              <td style='border:1px solid black; padding: 4px; width: ${columnWidth}'>
                ${data0.title.includes("EBITDA %") || data0.title.includes("PAT %")
            ? `${data0.title} (in percentage)`
            : data0.title.replace(/Days/g, "days").replace(/\(in days\)/g, "(days)")
          }
              </td>
              ${dynamicColumns1.map(columnKey => {
            const cellContent = rowsToSkipFormatting.includes(data0.title)
              ? formatToTwoDecimal(data0[columnKey]) || ""
              : formatAmount(data0[columnKey]) || "";
            return `<td style="text-align: right; border:1px solid black; padding: 4px; width: ${columnWidth}">${cellContent}</td>`;
          }).join('')}
            </tr>`;
      }).join("")
      : "";
    const columnsFinantialSummary = `
                    <thead>
                        <tr>
                            <th style="border: 1px solid #000; padding: 8px;">Particulars</th> 
                            ${dynamicColumns.map(year => `<th style="border: 1px solid #000; padding: 8px; text-align: center">${year}</th>`).join("")} 
                        </tr>
                    </thead>`;
    let finSummary = "";
    if (probeData?.finSummary?.data[0]?.data.length) {
      finSummary = `
            <p><br></p>
            <div class="OutlineElement Ltr SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; clear: both; cursor: text; overflow: visible; position: relative; direction: ltr; color: rgb(0, 0, 0); font-family: &quot;Segoe UI&quot;, &quot;Segoe UI Web&quot;, Arial, Verdana, sans-serif; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; white-space: normal; background-color: rgb(255, 255, 255); text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; font-size: 12px;">
                <p class="Paragraph SCXW91584501 BCX0" paraid="383431057" paraeid="{92348b89-550b-460e-b6d0-969d803a9340}{8}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px -1px 0px 0px; padding: 0px; user-select: text; overflow-wrap: break-word; white-space: pre-wrap; font-weight: normal; font-style: normal; vertical-align: baseline; font-kerning: none; background-color: transparent; color: windowtext; text-align: left; text-indent: 0px;"><span data-contrast="none" xml:lang="EN-US" lang="EN-US" class="TextRun Underlined SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; color: rgb(0, 0, 0); line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; font-weight: bold; font-variant-ligatures: none !important; font-size: 11pt;"><span class="NormalTextRun SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text;">Financial Summary (Amount in Cr.):</span></span><span class="EOP SCXW91584501 BCX0" data-ccp-props="{&quot;201341983&quot;:0,&quot;335551550&quot;:6,&quot;335551620&quot;:6,&quot;335559685&quot;:-567,&quot;335559737&quot;:-13,&quot;335559739&quot;:0,&quot;335559740&quot;:240}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; color: rgb(0, 0, 0); font-size: 11pt;"><br></span></p>
                <p class="Paragraph SCXW91584501 BCX0" paraid="383431057" paraeid="{92348b89-550b-460e-b6d0-969d803a9340}{8}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px -1px 0px 10px; padding: 0px; user-select: text; overflow-wrap: break-word; white-space: pre-wrap; font-weight: normal; font-style: normal; vertical-align: baseline; font-kerning: none; background-color: transparent; color: windowtext; text-align: left; text-indent: 0px;"><span class="EOP SCXW91584501 BCX0" data-ccp-props="{&quot;201341983&quot;:0,&quot;335551550&quot;:6,&quot;335551620&quot;:6,&quot;335559685&quot;:-567,&quot;335559737&quot;:-13,&quot;335559739&quot;:0,&quot;335559740&quot;:240}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; color: rgb(0, 0, 0); font-size: 11pt;"><br></span></p>
                <table style="width: 100%; border-collapse: collapse; border: 1px black solid; font-size: 12px; margin-top: 2px">
                ${columnsFinantialSummary}
                    <tbody>
                        ${finacialSumaryData}
                    </tbody>
                </table>
            </div>`
    }

    let customerDetails = ""
    if (probeData?.customerSupplier?.customerList?.length > 0 && probeData?.customerSupplier?.customerList[0]?.name != "") {
      // Extract customer list
      const customerList = probeData.customerSupplier.customerList;
      const customerRows = customerList
        .map(
          customer => `
              <tr>
                <td style='border:1px solid black; padding: 4px; font-size: 12px'>${customer.name}</td>
                <td style='border:1px solid black; padding: 4px; font-size: 12px; text-align: right'>${formatconvert(customer.amount)}</td>
                <td style='border:1px solid black; padding: 4px; font-size: 12px'>${customer.country}</td>
                <td style='border:1px solid black; padding: 4px; font-size: 12px'>${customer.product}</td>
                <td style='border:1px solid black; padding: 4px; font-size: 12px'>${customer.creditPeriod}</td>
              </tr>
            `
        )
        .join('');

      // Create the dynamic table
      customerDetails = `
             <p><br></p>
          <div class="OutlineElement Ltr SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; clear: both; cursor: text; overflow: visible; position: relative; direction: ltr; color: rgb(0, 0, 0); font-family: &quot;Segoe UI&quot;, &quot;Segoe UI Web&quot;, Arial, Verdana, sans-serif; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; white-space: normal; background-color: rgb(255, 255, 255); text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; font-size: 12px;">
            <p class="Paragraph SCXW91584501 BCX0" paraid="383431057" paraeid="{92348b89-550b-460e-b6d0-969d803a9340}{8}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px -1px 0px 0px; padding: 0px; user-select: text; overflow-wrap: break-word; white-space: pre-wrap; font-weight: normal; font-style: normal; vertical-align: baseline; font-kerning: none; background-color: transparent; color: windowtext; text-align: left; text-indent: 0px;"><span data-contrast="none" xml:lang="EN-US" lang="EN-US" class="TextRun Underlined SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; color: rgb(0, 0, 0); line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; font-weight: bold; font-variant-ligatures: none !important; font-size: 11pt;"><span class="NormalTextRun SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text;">Customer Details: </span></p>
            <p class="Paragraph SCXW91584501 BCX0" paraid="383431057" paraeid="{92348b89-550b-460e-b6d0-969d803a9340}{8}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px -1px 0px 10px; padding: 0px; user-select: text; overflow-wrap: break-word; white-space: pre-wrap; font-weight: normal; font-style: normal; vertical-align: baseline; font-kerning: none; background-color: transparent; color: windowtext; text-align: left; text-indent: 0px;"><span class="EOP SCXW91584501 BCX0" data-ccp-props="{&quot;201341983&quot;:0,&quot;335551550&quot;:6,&quot;335551620&quot;:6,&quot;335559685&quot;:-567,&quot;335559737&quot;:-13,&quot;335559739&quot;:0,&quot;335559740&quot;:240}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; color: rgb(0, 0, 0); font-size: 11pt;"><br></span></p>
            <table style="width: 100%; border-collapse: collapse; font-size: 12px; margin-top: 2px;">
              <thead>
                <tr>
                  <th style='border:1px solid black; padding: 8px; font-size: 12px; text-align: center; width:20%'>Customer Name</th>
                  <th style='border:1px solid black; padding: 8px; font-size: 12px; text-align: center; width:20%'> Amount in Cr.</th>
                  <th style='border:1px solid black; padding: 8px; font-size: 12px; text-align: center; width:20%'>Country </th>
                  <th style='border:1px solid black; padding: 8px; font-size: 12px; text-align: center; width:20%'>Products</th>
                  <th style='border:1px solid black; padding: 8px; font-size: 12px; text-align: center; width:20%'>Credit Period</th>
                </tr>
              </thead>
              <tbody>
                ${customerRows}
              </tbody>
            </table>
          </div>
        `;
    }

    let supplierDetails = ""
    if (probeData?.customerSupplier?.supplierList?.length > 0 && probeData?.customerSupplier?.supplierList[0]?.name != "") {
      // Extract Supplier list
      const supplierList = probeData.customerSupplier.supplierList;

      // Generate table rows dynamically
      const supplierRows = supplierList
        .map(
          supplier => `
              <tr>
                <td style='border:1px solid black; padding: 4px; font-size: 12px'>${supplier.name}</td>
                <td style='border:1px solid black; padding: 4px; font-size: 12px; text-align: right'>${formatconvert(supplier.amount)}</td>
                <td style='border:1px solid black; padding: 4px; font-size: 12px'>${supplier.country}</td>
                <td style='border:1px solid black; padding: 4px; font-size: 12px'>${supplier.product}</td>
                <td style='border:1px solid black; padding: 4px; font-size: 12px'>${supplier.creditPeriod}</td>
              </tr>
            `
        )
        .join('');

      // Create the dynamic table
      supplierDetails = `
             <p><br></p>
          <div class="OutlineElement Ltr SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; clear: both; cursor: text; overflow: visible; position: relative; direction: ltr; color: rgb(0, 0, 0); font-family: &quot;Segoe UI&quot;, &quot;Segoe UI Web&quot;, Arial, Verdana, sans-serif; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; white-space: normal; background-color: rgb(255, 255, 255); text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; font-size: 12px;">
            <p class="Paragraph SCXW91584501 BCX0" paraid="383431057" paraeid="{92348b89-550b-460e-b6d0-969d803a9340}{8}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px -1px 0px 0px; padding: 0px; user-select: text; overflow-wrap: break-word; white-space: pre-wrap; font-weight: normal; font-style: normal; vertical-align: baseline; font-kerning: none; background-color: transparent; color: windowtext; text-align: left; text-indent: 0px;"><span data-contrast="none" xml:lang="EN-US" lang="EN-US" class="TextRun Underlined SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; color: rgb(0, 0, 0); line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; font-weight: bold; font-variant-ligatures: none !important; font-size: 11pt;"><span class="NormalTextRun SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text;">Supplier Details: </span></p>
            <p class="Paragraph SCXW91584501 BCX0" paraid="383431057" paraeid="{92348b89-550b-460e-b6d0-969d803a9340}{8}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px -1px 0px 10px; padding: 0px; user-select: text; overflow-wrap: break-word; white-space: pre-wrap; font-weight: normal; font-style: normal; vertical-align: baseline; font-kerning: none; background-color: transparent; color: windowtext; text-align: left; text-indent: 0px;"><span class="EOP SCXW91584501 BCX0" data-ccp-props="{&quot;201341983&quot;:0,&quot;335551550&quot;:6,&quot;335551620&quot;:6,&quot;335559685&quot;:-567,&quot;335559737&quot;:-13,&quot;335559739&quot;:0,&quot;335559740&quot;:240}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; color: rgb(0, 0, 0); font-size: 11pt;"><br></span></p>
            <table style="width: 100%; border-collapse: collapse; font-size: 12px; margin-top: 2px;">
              <thead>
                <tr>
                  <th style='border:1px solid black; padding: 8px; font-size: 12px; text-align: center; width:20%'>Supplier Name</th>
                  <th style='border:1px solid black; padding: 8px; font-size: 12px; text-align: center; width:20%'> Amount in Cr.</th>
                  <th style='border:1px solid black; padding: 8px; font-size: 12px; text-align: center; width:20%'>Country </th>
                  <th style='border:1px solid black; padding: 8px; font-size: 12px; text-align: center; width:20%'>Products</th>
                  <th style='border:1px solid black; padding: 8px; font-size: 12px; text-align: center; width:20%'>Credit Period</th>
                </tr>
              </thead>
              <tbody>
                ${supplierRows}
              </tbody>
            </table>
          </div>
        `;
    }
    let products = '';
    if (probeData?.aboutSection?.products) {
      products = probeData?.aboutSection?.products;
    }
    const placeholderMappings = {
      entity_name: entityDetail?.entityName || "",
      description: `${probeData.aboutSection?.companyDescription}`,
      location: entityDetail?.addresses[0]?.state || "-" || "",
      credit_rating: `${probeData.aboutSection?.creditRating}`,
      loan_requirement: formatAmountloan(probeData.aboutSection?.loanRequirement) || "-" || "",
      deal_name: dealDetails?.dealName || "",
      totalAmount: finalTotalAmount,
      finacialSumaryData,
      columnsFinantialSummary,
      directors,
      shareHoldingDate: formatDateString(probeData?.directorSharehodlerList?.shareholdingsDate) || "",
      shareholdingData,
      termSheet: probeData.termsheet,
      extraFields,
      keyStrenghts,
      customerDetails,
      supplierDetails,
      debtProfile,
      products,
      finSummary,
      extraFieldsKeyStrengths
    };

    let replacedHtml = html;

    for (const [placeholderKey, value] of Object.entries(placeholderMappings)) {
      const placeholder = `((${placeholderKey}))`;
      if (value || placeholder == "((loan_requirement))") {
        replacedHtml = replacedHtml.replaceAll(placeholder, value);
      } else {
        replacedHtml = replacedHtml.replaceAll(placeholder, "");
      }
    }

    return replacedHtml;
  };

  const navigateBack = () => {
    navigate(-1);
  };

  const config = {
    removeButtons: ['about', 'preview', 'print'],
    showCharsCounter: false,
    showWordsCounter: false,
    showXPathInStatusbar: false,
  };

  const handleToast = (info) => {
    setToastInfo(info);
  };

  function formatFunction(file, showToastCallback) {
    const str = file.substring(file.indexOf("com") + 4);
    const filename = file.substring(file.lastIndexOf("/") + 1);
    const ext = str.split(".").pop();
    const obj = {
      fileName: str,
    };

    downloadSystemConfigFile(obj)
      .then((response) => {
        if (response.code === 200) {
          downloadFile(response.result, ext, filename);
          showToastCallback({
            message: "Downloaded successfully",
            showToast: true,
            role: "success",
          });
        } else {
          showToastCallback({
            message: response.message,
            showToast: true,
            role: "error",
          });
        }
      })
      .catch((error) => { });
  }

  const handleSubmitCam = async (ele) => {
    setIsSubmitting(true); // Start submit loading
    try {
      validation.setFieldValue("assignedToFirm", ele.values.assignedToFirm);

      const response = await callGetCIUser();
      if (response.code === 200 && response.status) {
        setUserList(response?.data?.rows);
      }

      setIsStatusModal(true);
    } catch (error) {
      console.error("Error in handleSubmitCam:", error);
    }
  }

  const dialogActionAccept = (action, data) => {
    if (action == 1) {
      setShowCommonDialog({ isShow: false })
      downloadCamProfile(data.camProfile)
        .then((response) => {
          setIsStatusModal(!isStatusModal);
          handleDownloadCam()
          getCamData({ dealId })
            .then((response) => {
              if (response) {
                setProbeData(response?.data[0] || "")
              } else {
                setProbeData([])
              }
            })
            .catch((error) => {
            });
          setToastInfo({
            message: "CAM submitted Successfully",
            showToast: true,
            role: "success",
          });
        })
      setIsSubmitting(false)
    } else {
      setIsSubmitting(false)
      setShowCommonDialog({ isShow: false })
    }
  }

  const handleApprove = async (ele) => {
    setIsApproving(true); // Start Approve loading
    try {
      validation1.setFieldValue("financierId", ele.values.financierId);
      const user = decryptedValue(localStorage.getItem("user"));
      const response = await getDeal({
        page: 1,
        limit: 1,
        searchKey: dealDetails?.dealName,
        columnName: "id",
        sortingOrder: 'ASC',
        filterType: "",
        user,
        filter: '',
        decodedealsId: ''
      });
      if (response.code === 200 && response.status) {
        setFinacierDetails(response.data?.data[0]?.financierData);
      }
      setIsApproveModal(true);
    } catch (error) {
      console.error("Error in handleSubmitCam:", error);
    }
  }

  const dialogActionApprove = (action, data) => {
    if (action == 1) {
      setShowCommonDialogApprove({ isShow: false })
      approveCam({
        id: probeData.id, camProfile: content, entityName: entityDetail[0].entityName,
        dealName: dealDetails.dealName, documents: validation.values.documents, financierId: validation1.values.financierId,
      })
        .then((response) => {
          if (response) {
            callDealEsign(data.camProfile)
              .then((response) => {
                if (response.code == 201 && response.status) {
                  setIsApproveModal(!isApproveModal);
                  setToastInfo({
                    message: "CAM Approved Successfully",
                    showToast: true,
                    role: "success",
                  });
                }
                getCamData({ dealId })
                  .then((response) => {
                    if (response) {
                      setProbeData(response?.data[0] || "")
                    } else {
                      setProbeData([])
                    }
                  })
                  .catch((error) => {
                  });
                setIsApproving(false)
              })
              .catch((error) => { });

          }
        })
        .catch((error) => { });

    } else {
      setIsApproving(false)
      setShowCommonDialogApprove({ isShow: false })
    }
  }

  const handleDownloadCam = () => {
    setToastInfo({
      message: 'Downloading please wait...',
      showToast: true,
      role: "success",
    })
    downloadCam({
      id: probeData.id, camProfile: content, entityName: entityDetail[0].entityName,
      dealName: dealDetails.dealName
    })
      .then((response) => {
        if (response.code == 200 && response.status) {
          if (response) {
            formatFunction(response.data?.fileLocation[0].fileName, handleToast)
          } else {
            setToastInfo({
              message: response.data?.fileLocation[0].message,
              showToast: true,
              role: "error",
            });
          }
        }
      })
  }

  const capitalizeFirstLetter = (inputString) => {
    if (typeof inputString !== "string" || inputString.length === 0) {
      return inputString;
    }
    return inputString.charAt(0).toUpperCase() + inputString.slice(1);
  };

  useImperativeHandle(ref, () => ({
    handleSubmit: () => handleSubmitCam(validation),
    handleApprove: () => handleApprove(validation1),
    getValidationStatus: () =>
      validation.validateForm().then((errors) => Object.keys(errors).length === 0),
    isSubmitting: () => isSubmitting,
    isApproving: () => isApproving,
    camData: () => probeData,
  }));
  const handleMulti = (selectedOptions) => {
    const newData = [];
    selectedOptions.forEach((ele) => {
      newData.push(ele.value);
    });
    validation1.setFieldValue("financierId", newData);
    setSelectedMulti(selectedOptions);
  };
  const customStyles = {
    control: (base) => ({
      ...base,
      textAlign: 'left', // Align text to the left
    }),
    menu: (base) => ({
      ...base,
      textAlign: 'left', // Align text in the dropdown menu to the left
    }),
  };

  return (
    <React.Fragment>
      <div>
        {probeData.isApproved === 1 ? (
          <div>
            <div style={{ marginTop: "-6px", textAlign: "end" }}>
              <span
                style={{
                  color: "#21aa47",
                  fontSize: "20px",
                  cursor: "pointer",
                }}
              >
                <i
                  className="fas fa-file-download mx-3"
                  id="download-deal"
                  onClick={() => handleDownloadCam()}
                ></i>
              </span>
              <UncontrolledTooltip placement="top" target="download-deal">
                Download CAM
              </UncontrolledTooltip>
            </div>
          </div>
        ) : (
          null
        )}


        <Row>
          <Col xs="12">
            <FormikProvider value={validation}>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleShowStatusBucket(validation);
                  return false;
                }}
              >
                <Row>
                  <Col sm="12">
                    <div className="table-responsive react-table">
                      <Table
                        Table
                        striped
                        bordered
                        hover
                        style={{ width: "100%", backgroundColor: "white" }}
                      >
                        {/* <thead>
                    <tr>
                      <th>File Name *</th>
                      <th>Designation *</th>
                      <th></th>
                    </tr>
                  </thead> */}
                        <tbody>
                          <FieldArray
                            name="documents"
                            render={(arrayHelpers) => (
                              <>
                                {validation.values.documents.map((_, index) => (
                                  <TableRow
                                    key={index}
                                    index={index}
                                    onDelete={() => arrayHelpers.remove(index)}
                                    validation={validation}
                                  />
                                ))}
                                <tr>
                                  <td colSpan={3}>
                                    <span
                                      className="text-success"
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        arrayHelpers.push({ fileName: "", fileUpload: null })
                                      }
                                    >
                                      <i className="mdi mdi-plus me-1" /> Add Document
                                    </span>
                                  </td>
                                </tr>
                              </>
                            )}
                          />
                        </tbody>
                      </Table>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col sm={12}>
                    <JoditEditor
                      ref={editor}
                      value={content}
                      config={config}
                      onBlur={(newContent) => {
                        setContent(newContent);
                      }}
                    />
                  </Col>
                </Row>
              </Form>
            </FormikProvider>
          </Col>
        </Row>

      </div>
      <Modal
        isOpen={isStatusModal}
        role="dialog"
        autoFocus={true}
        centered
        data-toggle="modal"
        toggle={() => {
          setIsStatusModal(!isStatusModal);
          setIsSubmitting(false);
        }}
      >
        <div>
          <ModalHeader
            className="border-bottom-0"
            toggle={() => {
              setIsStatusModal(!isStatusModal);
              setIsSubmitting(false);
            }}
          ></ModalHeader>
        </div>
        <div className="modal-body">
          <div className="text-center mb-4">
            <div className="row justify-content-center">
              <div className="col-xl-10">
                <h4 className="text-success">Select User to Assign</h4>
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}
                >
                  <Col xl={12} className="mb-3">
                    <Label className="form-label text-start d-block">
                      Select CI User
                    </Label>
                    <Input
                      name="assignedToFirm"
                      type="select"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.assignedToFirm || null}
                      invalid={
                        validation.touched.assignedToFirm &&
                        validation.errors.assignedToFirm
                      }
                    >
                      <option value="">Select User</option>
                      {userList?.map((option) => (
                        <option key={uId()} value={option.id}>
                          {capitalizeFirstLetter(option.firstName) +
                            " " +
                            (option.lastName
                              ? capitalizeFirstLetter(option.lastName)
                              : "")}
                        </option>
                      ))}
                    </Input>
                    {validation.touched.assignedToFirm &&
                      validation.errors.assignedToFirm ? (
                      <FormFeedback type="invalid">
                        {validation.errors.assignedToFirm}
                      </FormFeedback>
                    ) : null}
                  </Col>

                  <Row>
                    <Col sm="12">
                      <div className="d-flex gap-3 justify-content-end">
                        <button
                          type="submit"
                          className="btn btn-success save-customer mt-2"
                        >
                          Submit
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={isApproveModal}
        role="dialog"
        autoFocus={true}
        centered
        data-toggle="modal"
        toggle={() => {
          setIsApproveModal(!isApproveModal);
          setIsApproving(false);
          setSelectedMulti([]);
        }}
      >
        <div>
          <ModalHeader
            className="border-bottom-0"
            toggle={() => {
              setIsApproveModal(!isApproveModal);
              setIsApproving(false);
              setSelectedMulti([]);
            }}
          ></ModalHeader>
        </div>
        <div className="modal-body">
          <div className="text-center mb-4">
            <div className="row justify-content-center">
              <div className="col-xl-10">
                <h4 className="text-success">Select Finacier to Assign</h4>
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation1.handleSubmit();
                    return false;
                  }}
                >
                  <Col xl={12} className="mb-3">
                    <Label className="form-label text-start d-block">
                      Select Finaciers
                    </Label>
                    <Select
                      name="financierId"
                      value={selectedMulti}
                      isMulti={true}
                      onChange={handleMulti}
                      className={`select-dropdown ${validation1.touched.financierId &&
                        validation1.errors.financierId
                        ? "is-invalid"
                        : ""
                        }`}
                      options={finacierDetails?.map((option, index) => ({
                        label: option.name,
                        value: option.id,
                      }))}
                      styles={customStyles}
                    />
                    {validation1.touched.financierId && validation1.errors.financierId ? (
                      <FormFeedback type="invalid">
                        {validation1.errors.financierId}
                      </FormFeedback>
                    ) : null}
                  </Col>
                  <Row>
                    <Col sm="12">
                      <div className="d-flex gap-3 justify-content-end">
                        <button
                          type="submit"
                          className="btn btn-success save-customer mt-2"
                        >
                          Submit
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
      {
        showCommonDialog &&
        <CommonDialog
          isShow={showCommonDialog.isShow}
          message={showCommonDialog.message} data={showCommonDialog.data}
          postitiveBtn={'Yes'} negativeBtn={'No'} onCloseFn={dialogActionAccept}
        />
      }
      {
        showCommonDialogApprove &&
        <CommonDialog
          isShow={showCommonDialogApprove.isShow}
          message={showCommonDialogApprove.message} data={showCommonDialogApprove.data}
          postitiveBtn={'Yes'} negativeBtn={'No'} onCloseFn={dialogActionApprove}
        />
      }
    </React.Fragment>
  );
});

function downloadFile(base64String, ext, fileName) {
  let source = "";
  if (ext == "zip") {
    source = `data:application/zip;base64,${base64String}`;
    const link = document.createElement("a");
    link.href = source;
    link.download = fileName;
    link.click();
  } else {
    source = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64String}`;
    const link = document.createElement("a");
    link.href = source;
    link.download = fileName;
    link.click();

  }
}
CamProfile.propTypes = {
  history: PropTypes.object,
};

CamProfile.displayName = "CamProfile"
export default CamProfile;